// Width math for the Rewards header button, shared by the width selector (used to size the button
// and reserve container room) and the widget (used to pre-size the points box so the count-up
// animates inside a stable width). Values mirror the box model in RewardsMedallionWidget.scss and
// the .wideContentButton padding in OwaHeaderButtonGroup.scss.
export const REWARDS_HORIZONTAL_PADDING_PX = 28; // .wideContentButton padding: 14px * 2
export const REWARDS_MEDAL_WIDTH_PX = 20; // .rewardsBadge width
export const REWARDS_ICON_GAP_PX = 4; // .rewardsIconContainer gap
// Tabular-figure digit advance at 14px Segoe UI, rounded up so reserved width never clips.
export const REWARDS_DIGIT_WIDTH_PX = 9;

// Medal-only width (no points): equals BUTTON_WIDTH so an unresolved balance reserves no extra room.
export const REWARDS_MEDAL_ONLY_WIDTH_PX: number =
    REWARDS_HORIZONTAL_PADDING_PX + REWARDS_MEDAL_WIDTH_PX;
export const REWARDS_BUTTON_CHROME_WIDTH_PX: number =
    REWARDS_MEDAL_ONLY_WIDTH_PX + REWARDS_ICON_GAP_PX;

export function getRewardsPointsWidthPx(digitCount: number): number {
    return digitCount * REWARDS_DIGIT_WIDTH_PX;
}
